import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import TextArea from '@/common/components/TextArea'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useMaintenanceFinancialReviewSimpleEntriesReject } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/financialReview/simpleEntries/useMaintenanceFinancialReviewSimpleEntriesReject'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { maintenanceFinancialReviewSimpleEntriesRejectSchema, MaintenanceFinancialReviewSimpleEntriesRejectSchemaValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/schemas/forwardings/financialReview/simpleEntries/maintenanceFinancialReviewSimpleEntriesReject.schema'
import { zodResolver } from '@hookform/resolvers/zod'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'

const FinancialReviewEntrySimpleEntryReject = () => {
  const { workflow, forwarding } = useForwardingTabContext()

  const { id } = useParams()

  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { mutate: reject, isPending: rejectIsPending } = useMaintenanceFinancialReviewSimpleEntriesReject({
    financialReviewEntryId: workflow?.current_forwarding?.financial_review_entry?.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceForwarding', forwarding.id],
        })

        queryClient.invalidateQueries({
          queryKey: ['maintenanceWorkflow', id],
        })
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setError, setMessages
        })(error)
      },
    },
  })

  const {
    register,
    reset,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm<MaintenanceFinancialReviewSimpleEntriesRejectSchemaValidationSchema>({
    resolver: zodResolver(maintenanceFinancialReviewSimpleEntriesRejectSchema),
  });

  useEffect(reset, [isOpen])

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            variant="yellow"
            operationKlassToCheckPermission="Client::Maintenance::FinancialReview::SimpleEntries::Reject"
          >
            Declinar
          </Button>
        )}
        useCancellableFooter
        confirmButtonClassName="rounded-br-lg"
        cancelButtonClassName="rounded-bl-lg"
        onConfirm={handleSubmit((data) => reject(data))}
        confirmButtonIsLoading={rejectIsPending}
        title="Você tem certeza?"
        subtitle="Essa ação não é reversível."
        titleClass="text-2xl"
        subtitleClassName="text-base mt-1"
        showClose={false}
        body={(
          <form className="flex flex-col gap-4">
            <TextArea
              className="text-white-800 opacity-80"
              label="Motivo da rejeição"
              {...register('rejected_reason')}
              markAsRequired
              errorMessage={errors.rejected_reason?.message || undefined}
              maxLength={512}
            />
          </form>
        )}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}

export default FinancialReviewEntrySimpleEntryReject
